module.exports = __webpack_public_path__ + "media/Dicas.73afb21a.mp3";